<template>
  <div>
    <div v-if="selectedItem" class="form-control d-flex align-items-center">
      <span class="flex-grow-1">{{ selectedItem.name }}</span>
      <a class="icon-btn text-muted" title="Fjern kobling" @click="clearSelection">
        <font-awesome-icon :icon="['fas', 'times']"/>
      </a>
    </div>
    <div v-else class="position-relative">
      <input class="form-control" type="text" v-model="searchText" :placeholder="placeholder" style="padding-right:32px"
             @focus="showResults = true" @blur="onBlur"/>
      <!-- mousedown.prevent keeps the input focused so the result list stays open -->
      <a v-if="searchText" class="bo_search-clear" title="Tøm søket" @mousedown.prevent="searchText = ''">
        <font-awesome-icon :icon="['fas', 'times']"/>
      </a>
      <div v-if="showResults && groupedItems.length > 0" class="bo_item-picker-results">
        <div v-for="group in groupedItems" :key="group.id">
          <div class="bo_item-picker-category">{{ group.name }}</div>
          <!-- mousedown.prevent keeps the input from blurring before the click registers -->
          <a v-for="item in group.items" :key="item.id" class="bo_item-picker-result" @mousedown.prevent="selectItem(item)">
            {{ item.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Søk etter produkt...' }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      searchText: '',
      showResults: false
    };
  },
  computed: {
    selectedItem(){
      return this.items.find(item => item.id === this.modelValue) || null;
    },
    filteredItems(){
      let query = this.searchText.trim().toLowerCase();
      if(!query){
        return this.items;
      }
      return this.items.filter(item => item.name && item.name.toLowerCase().includes(query));
    },
    groupedItems(){
      //Group the matching items by category, in the categories' sort order
      let groups = [];
      let remaining = this.filteredItems.slice();
      let sortedCategories = this.categories.slice().sort((a, b) => a.sortOrder - b.sortOrder);
      for(let i = 0; i < sortedCategories.length; i++){
        let category = sortedCategories[i];
        let itemsOfCategory = remaining.filter(item => item.categoryId === category.id);
        if(itemsOfCategory.length > 0){
          itemsOfCategory.sort((a, b) => a.sortOrder - b.sortOrder);
          groups.push({ id: category.id, name: category.name, items: itemsOfCategory });
          remaining = remaining.filter(item => item.categoryId !== category.id);
        }
      }
      if(remaining.length > 0){
        groups.push({ id: 'no_category', name: 'Uten kategori', items: remaining });
      }
      return groups;
    }
  },
  methods: {
    selectItem(item){
      this.searchText = '';
      this.showResults = false;
      this.$emit('update:modelValue', item.id);
      this.$emit('change');
    },
    clearSelection(){
      this.$emit('update:modelValue', '');
      this.$emit('change');
    },
    onBlur(){
      this.showResults = false;
    }
  }
}
</script>
